// src/auth/PublicOnlyRoute.tsx
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../auth/auth.store';

/**
 * Routes reachable ONLY by guests (login, register, verify).
 * Authenticated users are redirected to `redirectTo` (default "/").
 */
export default function PublicOnlyRoute({
  redirectTo = '/',
}: {
  redirectTo?: string;
}) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const bootstrapped = useAuthStore((s) => s.bootstrapped);
  const location = useLocation();

  // Wait for /auth/me to resolve before deciding
  if (!bootstrapped) return null; // or a spinner

  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  return <Outlet />;
}